import React from 'react';
import ReactTooltip from 'react-tooltip';
import { TooltipContainer, IconContainer, StyledText } from './GuestHierarchyInfo.style';

const GuestHierarchyInfo: React.FunctionComponent = () => {
    return (
        <>
            <IconContainer data-tip data-for="info">
                ?
            </IconContainer>
            <ReactTooltip id="info" place="right" padding="0px" effect="solid">
                <TooltipContainer>
                    <StyledText text={'guestHierarchyInfo.title'} />
                    <StyledText text={'guestHierarchyInfo.content'} type="small" />
                </TooltipContainer>
            </ReactTooltip>
        </>
    );
};

export default GuestHierarchyInfo;
